import { DELIMITER_CHARS, EapSettingsImportDelimiter } from './settings-devices-eap-settings-import-modal.model';

export const extractPemFilenames = (csvContent: string, delimiter: EapSettingsImportDelimiter): string[] => {
    if (!csvContent) {
        return [];
    }
    const lines = csvContent.split(/\r?\n/);
    const delimiterChar = DELIMITER_CHARS[delimiter];
    const pemFiles = new Set<string>();

    for (const line of lines) {
        const cells = line.split(delimiterChar);
        for (const cell of cells) {
            const trimmed = cell.trim();
            if (trimmed.endsWith('.pem')) {
                pemFiles.add(trimmed);
            }
        }
    }

    return Array.from(pemFiles);
};
